<template>
  <div 
    class="back-to-top"
    :class="{ 'visible': isVisible }"
    @click="scrollToTop"
  >
    <i class="icon-arrow-up"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      screenHeight: window.innerHeight
    };
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleScroll() {
      // 当滚动距离超过1倍屏幕高度时显示按钮
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.isVisible = scrollTop > this.screenHeight * 1;
    },
    handleResize() {
      // 窗口大小变化时更新屏幕高度
      this.screenHeight = window.innerHeight;
    },
    scrollToTop() {
      // 平滑滚动到顶部
      const scrollToTop = window.setInterval(() => {
        const position = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (position > 0) {
          window.scrollTo(0, position - Math.max(20, position / 10));
        } else {
          window.clearInterval(scrollToTop);
        }
      }, 16);
    }
  }
};
</script>

<style scoped>
.back-to-top {
  position: fixed;
  bottom: 50px;
  right: 50px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #f00; /* Vue标志性绿色 */
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateY(20px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
}

.back-to-top.visible {
  opacity: 1;
  transform: translateY(0);
}

.icon-arrow-up::before {
  content: "↑";
  font-size: 20px;
}
</style>
